export const DEBT_WORK_STATUS_LABELS = {
  processing: 'Processing',
  invalidated: 'Invalidated',
  paymentPlanMade: 'Payment plan made',
}

export const DEBT_WORK_STATUS_OPTIONS = Object.entries(DEBT_WORK_STATUS_LABELS)
  .map(([value, label]) => ({ value, label }))

export const DEBT_WORK_STATUS_COMMENT_LIMIT = 500

export const DEBT_WORK_STATUS_UNSIGNED_HINT = 'Progress can be recorded once the debt is signed.'

const EDIT_ROLES = ['customer', 'user']

export const canEditDebtWorkStatus = (role) => EDIT_ROLES.includes(role)

export const debtWorkStatusLabel = (value) =>
  Object.prototype.hasOwnProperty.call(DEBT_WORK_STATUS_LABELS, value) ? DEBT_WORK_STATUS_LABELS[value] : ''

export const accountLastFour = (accountNumber) =>
  String(accountNumber ?? '').replace(/[^0-9a-zA-Z]/g, '').slice(-4)
